<template>
  <el-card>
    <el-form id="elForm" class="form-inline" size="medium"
      :model="queryForm" ref="queryForm" :inline="true" label-position="right" label-width="80px" >
      <template v-for="(item, index) in codeComs">
        <component @batchChange="batchChange" :is="item.type" :key="index" :comObj.sync="item.subElements || item.value" :lab="item.label"></component>
      </template>
      <el-form-item>
        <el-button class="btn-primary" type="primary" @click="query()">查询</el-button>
        <el-button type="medium" @click="reset()">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="setBut" v-for="(item, index) in operation" :key="index" v-show="operation.length>0">
      <op-box :btnList="operation" @clickOpBtn="clickOpBtn"></op-box>
    </div>
    <div class="mainTable">
      <!-- 表格标题 -->
      <div class="titleHead" v-show="titleHead!=''">{{titleHead}}</div>
      <!-- 筛选器 -->
      <!-- <div class="filtBox">
        <button :class="['filt_btn', {'on': filtShow}]" @click="filtTable($event)"></button>
        <ul class="filt_ul" ref="filtUl" v-show="filtShow">
          <li v-for="(item, iidx) in filtedTab" :key="iidx">
            <el-checkbox
              v-model="item.show"
              :label="item.name"
              ref="filtCheck"
              :disabled="iidx === 0">
            </el-checkbox>
          </li>
        </ul>
      </div> -->
      <!-- 表格主体 -->
      <el-table border class="tablebody" role="grid" :data="tableData" v-loading="tableLoading" element-loading-text="拼命加载中" style="width: 100%">
        <template v-for='(item, index) in tableHeader'>
          <el-table-column v-if="item.subNodes!=undefined&&item.subNodes.length>0&&filtedTab[index].show" :label="item.name" :key="index">
            <template v-for='(data, didx) in item.subNodes'>
              <el-table-column v-if="data.subNodes!=undefined&&data.subNodes.length>0" :label="data.name" :key="didx">
                <template v-for='(list, lidx) in data.subNodes'>
                  <el-table-column v-if="list.subNodes!=undefined&&list.subNodes.length>0" :label="list.name" :key="lidx">
                    <template v-for='(th, tidx) in list.subNodes'>
                      <el-table-column :prop="th.id" :label="th.name" :key="tidx"></el-table-column>
                    </template>
                  </el-table-column>
                  <el-table-column v-else :prop="list.id" :label="list.name" :key="lidx"></el-table-column>
                </template>
              </el-table-column>
              <el-table-column v-else :prop="data.id" :label="data.name" :key="didx"></el-table-column>
            </template>
          </el-table-column>
          <el-table-column v-else-if="filtedTab[index].show" :prop="item.id" :label="item.name" :key="index"></el-table-column>
        </template>
      </el-table>
      <!--分页-->
      <!-- <el-pagination :current-page.sync="pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total_rows"
        @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top: 10px;">
      </el-pagination> -->
    </div>
  </el-card>
</template>
<script>
import Vue from 'vue'
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
import dateRange from './codeCom/dateRange'
import physicalType from './codeCom/physicalType'
import opBox from './codeCom/operationBox'


export default {
  name: 'reports',
  data () {
    return {
      reportID: '',
      codeComs: [],
      queryForm: {},
      dafaultForm: {},
      operation: [],
      titleHead: '',
      tableHeader: [],
      pageNum: 1,
      pageSize: 10,
      tableLoading: true,
      tableData: [], // 加载出来的表格数据
      filtShow: false,
      filtedTab: [],
      total_rows: 0,
      classId: 0,
      batchTotal: {},
      flag: 0,
      exportName: '',
      // codeComs: [
      //   // {component: 'dateRange', label: '体检日期', value: '[]', name: 'date'},
      //   // {component: 'dateCom', label: '日期：', value: '', name: 'date'},
      //   {
      //     component: 'dateRange',
      //     value: [
      //       {label: '体检日期', value: '', name: 'startDate'},
      //       {label: '体检日期', value: '', name: 'endDate'},
      //     ]
      //   },
      // ]
    }
  },
  components: {
    dateRange,
    physicalType,
    opBox
  },
  methods: {
    query () { // 查询按钮
      this.queryForm = this.getCondition()
      // console.log(this.queryForm)
      this.getList(this.queryForm)
    },
    getCondition () {
      let result = {}
      // console.log(this.codeComs)
      this.codeComs.forEach(item => {
        if(item.value) {
          result[item.name] = item.value
        } else if(item.subElements) {
          item.subElements.forEach(i => {
            result[i.name] = i.value
          })
        }
      })
      if (Object.getOwnPropertyNames(this.batchTotal).length > 0) {
        var batchTotal = this.batchTotal
        result = Object.assign(this.batchTotal, result);
      }
      return result
    },
    batchChange(val) {  // 选择器只能获取到当前的val，需要将批次所需的别的批次传出来
      this.batchTotal = val
      if(this.flag === 1) {
        this.queryForm = this.getCondition()
      }
    },
    pageSizeChange (val) { // 每页显示条数
      this.pageSize = val
    },
    pageCurrentChange (val) { // 分页
      this.queryForm.pageNum = val
      this.getList(this.queryForm)
    },
    getDate () {
      this.tableData = this.allDate
      // var star = this.pageSize * (this.pageNum - 1)
      // var end = this.pageSize * this.pageNum
      // this.tableData = this.allDate.slice(star, end)
    },
    getList (param) { // 获取页面列表
      let that = this
      // this.reportID = 'ecsChildPhysiqueStatistics'
      api.post(config.khsHost + 'report/buildReport.do', {reportID: this.reportID, params: this.queryForm}).then(function (data) {
        that.flag++
        if (data.success == true) {
          var table = data.body.table
          var operation = data.body.operation.elements
          if(that.flag == 1) {
            that.codeComs = data.body.condition.elements
            that.dafaultForm = {...that.getCondition()}
          }
          if(table.head.elements.length === 0) { // 没有表头时不能导出
            operation.forEach(item=> {
              if (item.id==="export") {
                item.disabled = true
              }
            })
            that.operation = operation
          } else {
            that.operation = operation
          }
          that.exportName = table.data.exportName ? table.data.exportName : ''
          if (table.data.name != '' && table.data.name != undefined) {
            that.titleHead = table.data.name
          } else {
            that.titleHead = ''
          }
          if (table.data.leftCaption != undefined && table.data.rightCaption != undefined) {
            that.captionShow = true
          }
          if (table.data.leftCaption) {
            that.leftCaption = table.data.leftCaption
          }
          if (table.data.rightCaption) {
            that.rightCaption = table.data.rightCaption
          }
          that.tableHeader = table.head.elements
          that.allDate = table.data.dataList
          that.filtedTab = that.tableHeader.map(item => {
            let obj = {}
            obj.name = item.name
            obj.show = true
            return obj
          })
          that.total_rows = that.allDate.length
          that.description = table.data.description == undefined ? '' : table.data.description
          that.getDate()

          // that.queryForm.
        }
        that.tableLoading = false
      })
    },
    filtTable (e) { // table筛选功能
      this.filtShow = !this.filtShow
    },
    clickOpBtn(obj){
      this[obj.name](obj.url)
    },
    export(url) {
      if(this.flag === 1) {
        this.queryForm = this.getCondition()
      }
      this.downloadXls(config.host+url, JSON.stringify({params: this.queryForm, reportID: this.reportID}), this.exportName)
    },
    downloadXls(url, pojo, filename) { //封装好的导出函数
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.responseType = 'arraybuffer';
      xhr.onload = function() {
        if(this.status === 200) {
          var type = xhr.getResponseHeader('Content-Type');
          var blob = new Blob([this.response], {
            type: type
          });
          if(typeof window.navigator.msSaveBlob !== 'undefined') {
            filename += '.xls';
            window.navigator.msSaveBlob(blob, filename);
          } else {
            var URL = window.URL || window.webkitURL;
            var downloadUrl = URL.createObjectURL(blob);
            if(filename) {
                // use HTML5 a[download] attribute to specify filename
                var a = document.createElement("a");
                // safari doesn't support this yet
                if(typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xls';
                    document.body.appendChild(a);
                    a.click();
                }
            } else {
              window.location = downloadUrl;
            }
            setTimeout(function() {
              URL.revokeObjectURL(downloadUrl);
            },
            100); // cleanup
          }
        }
      };
      xhr.setRequestHeader('Content-type', 'application/json');
      xhr.setRequestHeader('Haiziguo-Token', localStorage.getItem('Haiziguo-Token'));
      xhr.send(pojo);
    },
    reset() {
      this.queryForm = this.dafaultForm
      this.codeComs.forEach(item => {
        if(item.subElements && item.subElements.length>0) {
          item.subElements.forEach(child=> {
            child.value = this.dafaultForm[child.name]
          })
        } else {
          item.value = this.dafaultForm[item.name]
        }
      })
      // console.log(this.codeComs)
      this.getList()
    }
  },
  watch: {
    $route(val){
      //console.log(val.params)
      this.flag = 0
      this.reportID = val.params.reportID
      this.getList()
    }
  },
  created () {
    let that = this
    this.reportID = this.$route.params.reportID
    this.getList()
  },
  updated() {
    // 筛选列表行的筛选项框显示时，点击任意非筛选项框的位置，筛选项框隐藏
    if(this.filtShow === true) {
      document.addEventListener('click', (event) => {
        var evt = event.srcElement ? event.srcElement : event.target
        var filtUl = this.$refs.filtUl
        // 当点击元素不在筛选项框内，或者不是筛选按钮时
        if (filtUl && !filtUl.contains(evt) && evt.className !== 'filtBtn') {
          // 当点击元素不包含筛选项框，或者是opBox中非筛选框的位置
          if (!evt.contains(filtUl) || evt.className === 'opBox') {
            this.filtShow = false
          }
        }
      })
    }
  },
}
</script>

<style>
.setBut{
    padding: 15px 10px;
    border-top: 1px solid #ddd;
}
.filtBox {
  float: right;
  position: relative;
  margin-top: 5px;
  margin-bottom: 4px;
}
.filt_btn{
  border: none;
  font-size: 20px;
  height: 26px;
  width:40px;
  background:url('../../assets/img/setting.png')
}
.filt_btn.on{
  background:url('../../assets/img/settingHov.png')
}
.filtBox .filt_ul {
  border: 1px solid #ddd;
  border-bottom: none;
  width: 140px;
  position: absolute;
  z-index: 100;
  left: -100px;
  top: 26px;
  background: #fff;
  max-height: 211px;
  overflow-y: auto;
}
.filtBox .filt_ul li {
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
  color: #676a6c;
}
.filtBox .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #606266;
}
.tablebody th{
  text-align: center
}
.line_b_black {
  border-bottom: 1px solid #99a9bf;
  background-color: #fff;
}
.nav {
  height: 3rem;
}
.ibox-content{
  padding: 15px 20px 20px 20px;
}
.mainTable {
  border-top: 1px solid #ddd;;
}
.mainTable .filtBtn {
  margin-bottom: 6px;
}
.titleHead {
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 28px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/reports.vue?389e618a